import { borderRadiusSm, COLORS, marginMd, paddingMd } from 'assets/styled';
import { respondTo } from 'assets/styled/breakpoints';
import styled from 'styled-components';

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  background-color: ${COLORS.WHITE};
  max-width: 850rem;
  width: 100%;
  min-width: 500rem;
  border-radius: ${borderRadiusSm};
  padding: ${paddingMd};

  ${respondTo.midTablet`
    max-width: 100%;
    min-width: auto;
  `}
`;

export const RowSpaceBetween = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
`;

export const Heading = styled.div`
  font-size: 24rem;
  line-height: 36rem;
  font-weight: 300;
  color: ${COLORS.BLACK};
  margin-bottom: ${marginMd};
`;

export const ValueWrapperRelative = styled.div`
  cursor: pointer;
  display: flex;
  position: relative;
`;

export const ContentWrapper = styled.div`
  display: flex;
  width: 100%;

  ${respondTo.smallTablet`
    max-width: 100%;
  `}
`;

export const LeftSide = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 20rem;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20rem;
`;

export const RightSide = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 20rem;
`;

export const LabelKey = styled.label`
  font-weight: 600;
  font-size: 16rem;
  line-height: 21rem;
  color: ${COLORS.BLACK};
`;

export const LabelKeyWrapper = styled.div`
  width: fit-content;
`;

export const LabelValue = styled.label`
  font-weight: 300;
  font-size: 16rem;
  line-height: 21rem;
  color: ${COLORS.BLACK};
`;

export const Subtitle = styled.label`
  font-weight: 300;
  font-size: 16rem;
  line-height: 16rem;
  margin-bottom: 20rem;
  display: block;
  color: ${COLORS.BLACK};
`;

export const CompanyLogoImg = styled.img`
  margin-top: ${marginMd};
  border-radius: ${borderRadiusSm};
  height: fit-content;
  max-width: 340rem;
`;
